import { render, staticRenderFns } from "./VMultiSelectField.vue?vue&type=template&id=4162f95e&"
import script from "./VMultiSelectField.vue?vue&type=script&lang=js&"
export * from "./VMultiSelectField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports